// @ts-nocheck

import { size as _size, mapValues as _mapValues, reduce as _reduce } from 'lodash';

import config from '../../../config/app.config';
import { BasketModes, BasketStatuses, BasketItemStatuses } from '../../../types/basket';
import { basket as BasketUtils } from '../../../utils';
import recomputeBasketStateForOperations from '../utils/recomputeBasketStateForOperations';

const { basket: BasketConfig } = config;
const { formatStake } = BasketUtils;
const { defaultStake } = BasketConfig;

const { generateSystems } = BasketUtils;

const switchMode = (state, action) => {
  const { items, mode, selectedFreebetId, freebets, stake } = state;
  const itemSize = _size(items);
  let nextStake = stake;

  let finalSystems = undefined;
  let finalMode = mode;
  let nextItems = { ...items };
  const { mode: nextMode } = action.payload;

  if (mode !== nextMode) {
    if (nextMode === BasketModes.SIMPLE) {
      finalMode = nextMode;
    } else if (nextMode === BasketModes.COMBINED && itemSize > 1) {
      finalMode = nextMode;
      if (selectedFreebetId) {
        const freebet = freebets[selectedFreebetId];
        if (freebet !== undefined) {
          const { amount } = freebet;
          nextStake = amount / 100;
        } else {
          nextStake = defaultStake;
        }
      }
    } else if (nextMode === BasketModes.SYSTEM && itemSize > 2) {
      finalMode = nextMode;
      nextItems = _mapValues(nextItems, (item) => ({
        ...item,
        banker: false,
      }));
      finalSystems = generateSystems({
        items: nextItems,
        defaultCheckboxValue: true,
      });
    }

    if (mode !== finalMode) {
      // NOTE : reset error message, betslip id, additional message on add item
      // NOTE: remove all items validated or waiting
      nextItems = _reduce(
        nextItems,
        (finalItems, item) => {
          const { status: itemStatus, oddId } = item;
          if (itemStatus !== BasketItemStatuses.VALIDATED && itemStatus !== BasketItemStatuses.WAITING) {
            return {
              ...finalItems,
              [oddId]: {
                ...item,
                status: BasketItemStatuses.OK,
                betslipId: undefined,
                error: undefined,
                additionalMessage: undefined,
                selectedFreebetId: undefined,
              },
            };
          }
          return finalItems;
        },
        {},
      );

      if (_size(nextItems) < 2) {
        finalMode = BasketModes.SIMPLE;
      }

      return {
        ...state,
        status: BasketStatuses.OK,
        mode: finalMode,
        items: nextItems,
        systems: finalSystems,
        stake: formatStake(nextStake),
        error: undefined,
        additionalMessage: undefined,
        betslipId: undefined,
        selectedFreebetId: undefined,
      };
    }
  }
  return state;
};

/**
 * Return the nextState corresponding to the BASKET_SWITCH_MODE action
 *
 * @param  {Object} state  The actual state.
 * @param  {Object} action The action to reduce.
 * @return {Object}        Return the new state.
 */

const basketSwitchMode = (state, action, globalState) => {
  const { status } = state;
  let nextState = state;

  if (status !== BasketStatuses.PENDING && status !== BasketStatuses.VALIDATED && status !== BasketStatuses.WAITING) {
    nextState = switchMode(nextState, action);

    if (nextState.mode !== state.mode) {
      nextState = recomputeBasketStateForOperations(nextState, globalState);
    }
  }

  return nextState;
};

export default basketSwitchMode;
